<template>
    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner />
    </b-container>
    <div v-else>
        <b-container>
            <b-tabs content-class="mt-3">

                <b- tab title="Хэштеги">

                    <b-row>
                        <b-col>
                            <a @click="tags.showOrHideAll()"
                                class="is-show-text"
                                href="#">
                                {{textIsShowAll}}</a>
                        </b-col>

                        <b-col class="h-end">
                            <b-row class="m-0">

                                <transition name="visibility-switch">
                                    <b-col v-if="tags.IsChanged" style="padding: 0 5px 0 0;">
                                        <b-button id="admin-btn-save" 
                                                class="admin-button" 
                                                @click="updateSorting">
                                            Сохранить
                                        </b-button>
                                    </b-col>
                                </transition>

                                <transition name="visibility-switch">
                                    <b-col v-if="tags.IsChanged" style="padding: 0 0 0 5px;">
                                        <b-button id="admin-btn-cancel" 
                                                class="admin-button" 
                                                @click="cancelChanges">
                                            Отменить
                                        </b-button>
                                    </b-col>
                                </transition>
                                
                                <b-col style="padding: 0 0 0 5px;">
                                    <b-button id="admin-btn-add" 
                                              class="admin-button" 
                                              @click="moveToEdit">
                                        Добавить
                                    </b-button>
                                </b-col>
                            </b-row>                          
                        </b-col>                        
                    </b-row>

                    <multi-tag-list :data="tags" :apiVersion="apiHeaders['api-Version']"/>

                </b->

                <b-tab title="Зависимости книг стандартов">
                    <multi-tag-dependency :options="tagsDependency" :apiVersion="apiHeaders['api-Version']"/>
                </b-tab>

            </b-tabs>
        </b-container>
    </div>
    
</template>

<script>
import AllRoutes from '@/routes/all.routes'

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import ApiHeaders from '@/store/models/ApiHeaders'


import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import TagsModel from '@/store/models/admin/tags/Tags'

import MultiTagList from '@/components/admin/tags/MultiTagList'
import MultiTagDependency from '@/components/admin/tags/MultiTagDependency'

export default {
    data: function() {
        let load = new Loading();

        let apiHeaders = new ApiHeaders().mapToDto(this.$route.query['api-Version']);

        this.getTags(load, apiHeaders);

        return {
            load: load,
            apiHeaders: apiHeaders,
            tagsDependency: [],

            tags: null,
            tagsClone: null
        }
    },
    computed: {
        textIsShowAll: function() {
            return this.tags.IsShowAll
                                ? 'Свернуть все'
                                : 'Развернуть все';                                            
        },
    },
    methods: {
        getTags: function(load, apiHeaders) {
            load.Calculate(true);
            apiService.Admin.Tags.StandardsBook.GetTags(apiHeaders)
                .then(response => {
                    this.tags = new TagsModel().mapFromDto(response.data.MainTags);
                    this.tagsClone = JSON.parse(JSON.stringify(new TagsModel().mapFromDto(response.data.MainTags)));
                    this.tagsDependency = response.data.StandardBooks;
                    load.Calculate(false);
                })
                .catch(error => load.Calculate(false));
        },
        moveToEdit: function () {
            this.$router.push({ path: AllRoutes.Admin.Tags.StandardsBook.Edit, query: { 'api-Version': this.apiHeaders['api-Version'] } })
        },
        updateSorting: function() {
            let tagsDto = this.tags.mapToDto();

            this.load.Calculate(true);
            apiService.Admin.Tags.StandardsBook.PostUpdateSorting(tagsDto, this.apiHeaders)
                .then(response => {
                    this.tags.IsChanged = false;
                    this.tagsClone = new TagsModel().mapFromDto(this.tags.Tags);
                    this.load.Calculate(false);
                })
                .catch(error => this.load.Calculate(false));

        },
        cancelChanges: function() {
            this.tags = new TagsModel().mapFromDto(this.tagsClone.Tags);
        }
    },
    components: {
        Spinner,
        MultiTagList,
        MultiTagDependency
    }
}
</script>